import { REQUEST_STATUS } from '../../../../lib/types';

export const DEFAULT_BULK_STATUSES = [REQUEST_STATUS.SENT, REQUEST_STATUS.LOCKED, REQUEST_STATUS.DRAFT];
export const DEFAULT_DRAFT_STATUSES = [REQUEST_STATUS.DRAFT];
export const DEFAULT_REQUEST_STATUSES = [REQUEST_STATUS.SENT, REQUEST_STATUS.LOCKED];
